// extracted by mini-css-extract-plugin
export default {"download-text-with-icon":"_download-text-with-icon_7-o-0n"};